<template>
  <pill v-bind="$attrs" :href='shareUrl' target='_blank'>Share this Story</pill>
</template>

<script>
export default {
  props: ['url'],
  computed: {
    shareUrl: function(){
      return 'https://www.addtoany.com/share#url=' + this.url
    }
  }
}
</script>
